import React from 'react';
import {Form as FormikForm, Formik, FormikHelpers, FormikValues} from 'formik';
import * as Yup from 'yup';
import PrimaryButton from '../../ui/PrimaryButton';
import TextButton from '../../ui/TextButton';
import UIInput from '../../ui/form/UIInput';
import FormSection from '../../ui/form/FormSection';
import FormField from '../../ui/form/FormField';
import UIWysiwig from '../../ui/form/UIWysiwig';
import {LicenseAgreement} from '../../models/brand/LicenseAgreement';
import {ButtonColour} from '../../ui/ButtonColour';
import IconTrash from '../icon/IconTrash';
import If from '../utils/If';
import Modal from '../../ui/modal/Modal';
import ModalTitle from '../../ui/modal/ModalTitle';
import ModalContent from '../../ui/modal/ModalContent';
import ModalButtons from '../../ui/modal/ModalButtons';

type FormProps = {
  backLink: string;
  agreement?: LicenseAgreement,
  onSubmit?: (input: any) => void;
  onDelete?: () => void
}

export default function AgreementForm({backLink, agreement, onSubmit, onDelete}: FormProps) {
  const [showDelete, setShowDelete] = React.useState(false);

  const onFormSubmit = (values: FormikValues, helpersReact: FormikHelpers<FormikValues>) => {
    helpersReact.setSubmitting(true);
    if (onSubmit) {
      onSubmit(values);
      helpersReact.setSubmitting(false);
    }
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowDelete(true);
  }

  const initialValues = {
    version: agreement?.version || '',
    content: agreement?.content || '',
    consent: agreement?.consent || ''
  };
  const validation = Yup.object({
    version: Yup.string().required('Required'),
    content: Yup.string().required('Required'),
    consent: Yup.string().required('Required')
  });

  return (
    <>
      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <ModalTitle title={'Delete agreement'}/>
        <ModalContent>
          <p>If you delete an agreement, your trainers will not be able to renew their license on their own.</p>
        </ModalContent>
        <ModalButtons>
          <PrimaryButton onClick={onDelete}>Delete</PrimaryButton>
          <TextButton onClick={() => setShowDelete(false)}>Cancel</TextButton>
        </ModalButtons>
      </Modal>
      <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onFormSubmit}>
        <FormikForm>
          <div className={'mb-5'}>
            <FormSection>
              <FormField id="version" label="Version">
                <UIInput name="version" id="version" className="w-full"/>
              </FormField>
              <FormField id="content" label="Agreement">
                <UIWysiwig name="content" id="content"/>
              </FormField>
              <FormField id="consent" label="Consent" tooltip="Text of the consent which trainers should give in order
              to renew their license">
                <UIWysiwig name="consent" id="consent"/>
              </FormField>
              <div className="pt-6 flex flex-row justify-between">
                <div className="flex flex-row justify-start">
                  <PrimaryButton className="w-32 mr-6">Save</PrimaryButton>
                  <TextButton onClick={() => window.location.assign(backLink)}>Cancel changes</TextButton>
                </div>
                <If condition={!!agreement}>
                  <TextButton onClick={handleDeleteClick} colour={ButtonColour.RED}>
                    <IconTrash/> Delete agreement</TextButton>
                </If>
              </div>
            </FormSection>
          </div>
        </FormikForm>
      </Formik>
    </>
  );
}
